
import { inAppRedirect } from '~/utils/route-redirects';

export default {
  name: 'NotificationRepost',
  props: {
    notif: {
      required: true,
      type: Object,
    },
  },
  methods: {
    goToTarget(targetId) {
      inAppRedirect(`/portfolios/${targetId}`);
    },
  },
};
